import { render, staticRenderFns } from "./CollectPhotoDetail.vue?vue&type=template&id=2e43c375&scoped=true&"
import script from "./CollectPhotoDetail.vue?vue&type=script&lang=js&"
export * from "./CollectPhotoDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectPhotoDetail.vue?vue&type=style&index=0&id=2e43c375&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e43c375",
  null
  
)

export default component.exports